import React from 'react';
import { Form, Icon, Input, Button, Spin, Row, Col } from 'antd';
import { Redirect, withRouter, Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import axios from "axios";
import './style.css';

const FormItem = Form.Item;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;


class PasswordResetForm extends React.Component {
    state = {

    };

    componentDidMount() {
        axios.defaults.xsrfCookieName = 'csrftoken';
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
        try {
            delete axios.defaults.headers.common["Authorization"];
        } catch (error) {
            ''
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                axios.post(process.env.REACT_APP_AXIOS_URL + "/rest-auth/password/reset/", values)
                    .then(res => {
                        if (res.status === 200) {
                            this.props.history.push({
                                pathname: '/login/',
                                state: { message: this.props.t('auth.password_reset.reset_sent', "Password reset link have been sent to your provided email.") }
                            });
                        }
                    });
                // this.props.history.push('/');
            }
        });
    }

    render() {
        const { t } = this.props;
        const { getFieldDecorator } = this.props.form;

        if (localStorage.getItem('token') === null || localStorage.getItem('token') === undefined) {
            return (
                <Row>
                    <Col md={12}>
                        <div className="login-page-background-image">

                        </div>
                    </Col>
                    <Col md={12} style={{ height: '100vh' }}>
                        <div className="login-wrap">
                            <img src="/static/nerisit-logo-final-light.png" className='login-logo-img'></img>
                            <p className='pStyle' style={{ textAlign: 'center' }}>Enter your email to reset password</p>
                            {
                                this.props.loading ?

                                    <Spin indicator={antIcon} />

                                    :

                                    <Form onSubmit={this.handleSubmit} className="login-form">
                                        <FormItem>
                                            {getFieldDecorator('email', {
                                                rules: [{
                                                    type: 'email', message: t('auth.password_reset.email_invalid', "The input is not valid Email!"),
                                                }, {
                                                    required: true, message: t('auth.password_reset.email_required', "Please input your email!")
                                                }],
                                            })(
                                                <Input prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={t('auth.password_reset.email', "Email")} />
                                            )}
                                        </FormItem>

                                        <FormItem>
                                            <Link
                                                className='login-form-forgot'
                                                // style={{ marginRight: '10px' }}
                                                to='/login/'> {t('auth.password_reset.login', "Login")}
                                            </Link>
                                            <Button type="primary" htmlType="submit" className="login-form-button">
                                                {t('auth.password_reset.reset', "Reset password")}
                                            </Button>
                                        </FormItem>
                                    </Form>
                            }

                        </div>
                    </Col>

                </Row>
            );
        } else {
            return (<Redirect to="/" />);
        }
    }
}

const WrappedPasswordResetForm = Form.create()(PasswordResetForm);

export default withRouter(withTranslation()(WrappedPasswordResetForm));


// WEBPACK FOOTER //
// ./src/containers/Auth/PasswordReset.js